import { render, staticRenderFns } from "./defectiveInspectionLabel.vue?vue&type=template&id=7e4783bc&scoped=true&"
import script from "./defectiveInspectionLabel.vue?vue&type=script&lang=js&"
export * from "./defectiveInspectionLabel.vue?vue&type=script&lang=js&"
import style0 from "./defectiveInspectionLabel.vue?vue&type=style&index=0&id=7e4783bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4783bc",
  null
  
)

export default component.exports